import { lazy } from 'react';

// Growz
const GrowzOverview = lazy(() => import('./overview/Main'));
const GrowzDashboard = lazy(() => import('./home/Main'));
const GrowzAnalytics = lazy(() => import('./analytics/Main'));
const GrowzCampaigns = lazy(() => import('./campaigns/Campaigns'));
const GrowzCampaign = lazy(() => import('./campaigns/Campaign'));
const GrowzAdGroups = lazy(() => import('./campaigns/AdGroups'));
const GrowzKeywordsEdit = lazy(() => import('./keywords/KeywordsEdit'));
const GrowzNotificationList = lazy(() => import('./notifications/Dashboard'));
const GrowzAccountSettings = lazy(() => import('./settings/Accountsettings'));
const GrowzProfileSettings = lazy(() => import('./settings/AccountSettings/ProfileSettings'));
const GrowzAccountChangePassword = lazy(() => import('./settings/AccountSettings/ChangePassword'));
const GrowzStoreProfileSettings = lazy(() => import('./settings/StoreSettings/StoreProfile'));
const GrowzStoreNotifications = lazy(() => import('./settings/StoreSettings/StoreNotifications'));
const GrowzStoreCustomName = lazy(() => import('./settings/StoreSettings/StoreCustomName'));
const GrowzStoreReconnect = lazy(() => import('./settings/StoreSettings/StoreReconnect'));

// Reports
const GrowzReportsDashboard = lazy(() => import('./reports/ReportsDashboard'));
const GrowzReportsComparison = lazy(() => import('./reports/ReportsComparison'));
const GrowzReportsPlacement = lazy(() => import('./reports/ReportsPlacement'));
const StoreKeywordReport = lazy(() => import('./reports/StoreKeywordReport'));
const StoreTargetsReport = lazy(() => import('./reports/StoreTargetsReport'));
const StoreSearchTermReport = lazy(() => import('./reports/StoreSearchTermReport'));
const StoreProductReport = lazy(() => import('./reports/StoreProductAds'));
const StoreCampaignReport = lazy(() => import('./reports/StoreCampaignReport'));
const StorePlacementReport = lazy(() => import('./reports/StorePlacementReport'));
const StoreBrandMetrics = lazy(() => import('./reports/StoreBrandMetricsReport'));
const StoreBrandMetricsCategoryReport = lazy(() => import('./reports/StoreBrandMetricsCategoryReport'));
const StoreKeywordsTargetsByAsinReport = lazy(() => import('./reports/StoreKeywordsTargetsByAsin'));
const GrowzSBAssets = lazy(() => import('./campaigns/SBAssets'));
const GrowzSBAssetsAdd = lazy(() => import('./campaigns/SBAssetsAdd.jsx'));

const GrowzMicroGoals = lazy(() => import('./microgoals/MicroGoals'));
const GrowzMicroGoal = lazy(() => import('./microgoals/MicroGoal'));
const GrowzMicroGoalsLaunched = lazy(() => import('./microgoals/MicroGoalsLaunched'));
const GrowzStrategies = lazy(() => import('./microgoals/StrategiesLaunchedByCampaign'));

// const GrowzMicroGoalActivity = lazy(() => import('./microgoals/activity/MicroGoalActivity.jsx'));
const GrowzMicroGoalActivityV2 = lazy(() => import('./microgoals/activityV2/MicroGoalActivity.jsx'));
const GrowzMicroGoalActivityEdit = lazy(() => import('./microgoals/activityV2/MicroGoalActivityEdit.jsx'));
// const GrowzMicroGoalActivityEdit = lazy(() => import('./microgoals/activity/MicroGoalActivityEdit.jsx'));
// const GrowzMicroGoalActivityLog = lazy(() => import('./microgoals/activity/MicroGoalActivityLog.jsx'));
const GrowzRecommendedGoals = lazy(() => import('./microgoals/RecommendedGoals'));
const GrowzLaunchGoals = lazy(() => import('./microgoals/GoalLaunch'));
const GrowzAuditIndex = lazy(() => import('./audit/Index'));
const GrowzCreatives = lazy(() => import('./creatives/Main'));
const GrowzMicroGoalReportsTarget = lazy(() => import('./microgoals/activityV2/MicroGoalActivityTargetReports.jsx'));
const GrowzMicroGoalReportsProducts = lazy(() => import('./microgoals/activityV2/MicroGoalActivityProductReports.jsx'));
const GrowzMicroGoalReportsCampagins = lazy(() => import('./microgoals/activityV2/MicroGoalActivityCampaginsReports.jsx'));
const growzMicroGoalActivityProjections = lazy(() => import('./microgoals/activityV2/MicroGoalActivityProjections'));

const adGroupTargetBiding = lazy(() => import('./campaigns/AdGroupTargetBiding'));
const adGroupTargetBidingDetails = lazy(() => import('./campaigns/AdGroupTargetBidingDetails'));
const adGroupKeywordScout = lazy(() => import('./campaigns/adGroupKeywordScout'));
const adGroupKeywordScoutView = lazy(() => import('./campaigns/adGroupKeywordScoutView'));
// const GrowzReports = lazy(() => import('./Reports'));

// Creative
const GrowzCreativesDashboard = lazy(() => import('./creatives/Dashboard'));
const GrowzCreative = lazy(() => import('./creative/Main'));
const GrowzCreativeSB = lazy(() => import('./creative/CreativeSB'));
const GrowzCreativeSD = lazy(() => import('./creative/CreativeSD'));

// Keyword Research
const GrowzKeywordResearch = lazy(() => import('./keywords/Main'));
// Keyword Research
const GrowzKeywordRevserAsin = lazy(() => import('./campaigns/ReverseAsin'));

// Amazon Rank Tracker
const GrowzRankTracker = lazy(() => import('./tracker/Main'));
const GrowzRankTrackerDashboard = lazy(() => import('./tracker/Dashboard'));

// analyze
const GrowzAnalyze = lazy(() => import('./analyze/Dashboard'));

// product pulse
const GrowzProducts = lazy(() => import('./products/Main'));
const GrowzProductStructure = lazy(() => import('./products/ProductsStructure'));
const GrowzProduct = lazy(() => import('./products/ProductPage'));

// payment
const GrowzSelectAddOns = lazy(() => import('./subscription/CheckoutFlow/SelectAddOns'));

// subscriptions
const GrowzSubscription = lazy(() => import('./subscription/SubscriptionDetails'));
const GrowzActivePlan = lazy(() => import('./subscription/SubscriptionDetails/GrowzActivePlan'));
const GrowzSubscriptionAdOns = lazy(() => import('./subscription/SubscriptionDetails/GrowzAddOns'));
const GrowzSubscriptionInvoices = lazy(() => import('./subscription/SubscriptionDetails/GrowzInvoices'));
const GrowzSubscriptionUsage = lazy(() => import('./subscription/SubscriptionDetails/GrowzUsage'));
const GrowzPaymentsPage = lazy(() => import('./subscription/Plans/CustomPlan'));
const AddTargetsToAdGroup = lazy(() => import('./keywords/AddTargetsToAdGroup.jsx'));
const AsinSPStructureFixDetails = lazy(() => import('./analyze/AsinSPStructureFixDetails'));
const AsinSDStructureFixDetails = lazy(() => import('./analyze/AsinSDStructureFixDetails'));
const AsinSBStructureFixDetails = lazy(() => import('./analyze/AsinSBStructureFixDetails'));
const AsinSPStructure = lazy(() => import('./analyze/AsinSPStructure'));
const AsinSDStructure = lazy(() => import('./analyze/AsinSDStructure'));
const AsinSBStructure = lazy(() => import('./analyze/AsinSBStructure'));
const AsinSearchTerms = lazy(() => import('./analyze/AsinSearchTerms'));
const AccountHealthPage = lazy(() => import('./AccountHealth/Main'));
const GrowzCampaignLauncher = lazy(() => import('./campaigns/CampaignLauncher'));
const GrowzSPCampaignLauncher = lazy(() => import('./campaigns/launcher/SPCampaignLauncher'));
const GrowzSDCampaignLauncher = lazy(() => import('./campaigns/launcher/SDCampaignLauncher'));
const GrowzSBCampaignLauncher = lazy(() => import('./campaigns/launcher/SBCampaignLauncher'));
const GrowzAuditReports = lazy(() => import('./analyze/AuditReports'));

export default {
  campaigns: GrowzCampaigns,
  dashboard: GrowzDashboard,
  analytics: GrowzAnalytics,
  notifications: GrowzNotificationList,
  settings: GrowzAccountSettings,
  campaign: GrowzCampaign,
  adGroups: GrowzAdGroups,
  microGoals: GrowzMicroGoals,
  microGoal: GrowzMicroGoal,
  keywordsEdit: GrowzMicroGoals,
  recommendedGoals: GrowzRecommendedGoals,
  goalLaunch: GrowzLaunchGoals,
  profileSettings: GrowzProfileSettings,
  changePassword: GrowzAccountChangePassword,
  storeProfile: GrowzStoreProfileSettings,
  storeNotifications: GrowzStoreNotifications,
  customName: GrowzStoreCustomName,
  storeReconnect: GrowzStoreReconnect,
  reports: GrowzReportsDashboard,
  reportsComparison: GrowzReportsComparison,
  reportsPlacement: GrowzReportsPlacement,
  subscription: GrowzSubscription,
  addOns: GrowzSelectAddOns,
  payments: GrowzPaymentsPage,
  usages: GrowzSubscriptionUsage,
  // growzMicroGoalActivity: GrowzMicroGoalActivity,
  // reports: GrowzReports,
  growzMicroGoalActivityV2: GrowzMicroGoalActivityV2,
  growzMicroGoalActivityEdit: GrowzMicroGoalActivityEdit,
  growzMicroGoalReportsTarget: GrowzMicroGoalReportsTarget,
  growzMicroGoalReportsProducts: GrowzMicroGoalReportsProducts,
  growzMicroGoalReportsCampagins: GrowzMicroGoalReportsCampagins,
  microGoalsLaunched: GrowzMicroGoalsLaunched,
  strategy: GrowzStrategies,
  growzMicroGoalActivityProjections,

  // growzMicroGoalActivityEdit: GrowzMicroGoalActivityEdit,
  GrowzKeywordResearch,
  GrowzKeywordRevserAsin,
  GrowzRankTracker,
  GrowzRankTrackerDashboard,
  // growzMicroGoalActivityLog: GrowzMicroGoalActivityLog,
  GrowzSBAssets,
  GrowzSBAssetsAdd,
  GrowzAuditIndex,
  GrowzCreatives,
  GrowzCreative,
  GrowzCreativesDashboard,
  GrowzCreativeSB,
  GrowzCreativeSD,
  GrowzKeywordsEdit,
  adGroupTargetBiding,
  adGroupTargetBidingDetails,
  adGroupKeywordScout,
  adGroupKeywordScoutView,
  GrowzAnalyze,
  GrowzProducts,
  GrowzProduct,
  GrowzOverview,
  GrowzActivePlan,
  GrowzProductStructure,
  StoreKeywordReport,
  StoreTargetsReport,
  StoreSearchTermReport,
  StoreProductReport,
  StoreCampaignReport,
  StorePlacementReport,
  GrowzSubscriptionAdOns,
  GrowzSubscriptionInvoices,
  AddTargetsToAdGroup,
  AsinSPStructureFixDetails,
  AsinSDStructureFixDetails,
  AsinSBStructureFixDetails,
  AsinSPStructure,
  AsinSDStructure,
  AccountHealthPage,
  AsinSearchTerms,
  AsinSBStructure,
  StoreBrandMetrics,
  StoreBrandMetricsCategoryReport,
  StoreKeywordsTargetsByAsinReport,
  GrowzCampaignLauncher,
  GrowzSPCampaignLauncher,
  GrowzSDCampaignLauncher,
  GrowzSBCampaignLauncher,
  GrowzAuditReports,
};
